//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import comShowye from "../../My/components/showYe.vue";
import GDialog from "@/common/components/g-dialog/";
import { common, commonApi } from "@/common/index";
export default {
  components: {
    comShowye,
    GDialog,
  },
  data() {
    return {
      typeList: [],
      isIcon: require("../../../assets/image/My/jymx.png"),
      isRemind: false,
      titleExtend: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    extendItem(idx) {
      if (this.titleExtend.includes(idx)) {
        const index = this.titleExtend.indexOf(idx);
        this.titleExtend.splice(index, 1);
      } else {
        this.titleExtend.push(idx);
      }
    },
    init() {
      const UUID =
        this.$store.state.UUID === ""
          ? this.$Cookies.get("UUID")
          : this.$store.state.UUID;
      commonApi.PAY.getNewPayType(UUID).then((data) => {
        this.typeList = data || [];
      });
    },
    handleSelectPayType({ payCode, parentCode, payViewName }) {
      // 获取相应的code来选择支付方式
      let query = { payCode, payViewName, parentCode };
      // let query = { payCode: 'GS_KH2VX1DX6P79', payViewName: '线上支付测试', parentCode: 'ONLINE' }
      if (parentCode === "TOBANK_IN") {
        // TOBANK_IN银行汇款
        this.$router.push({ path: "/SaveMonery/BankTransfer", query });
      } else if (parentCode == "ONLINE" || parentCode == "USDT") {
        this.$router.push({ path: "/SaveMonery/recharge", query });
      } else {
        this.$router.push({ path: "/SaveMonery/otherTransfer", query });
      }
    },
    handlePayType(item) {
      // 获取相应的code来选择支付方式
      // actionLogEvent("af_rechargeClick")   //上传点击充值
      let { payCode, payViewName, parentCode } = item;
      let query = { payCode, payViewName, parentCode };
      if (parentCode === "TOBANK_IN") {
        // TOBANK_IN银行汇款
        this.$router.push({ path: "/SaveMonery/BankTransfer", query });
      } else if (parentCode == "ONLINE" || parentCode == "USDT") {
        this.$router.push({ path: "/SaveMonery/recharge", query });
      } else if (item.parentCode == "SEMI_AUTOMATIC_ELECTRON") {
        // 半自动电子
        this.$router.push({ path: "/SaveMonery/otherTransfer2", query });
      } else if (item.parentCode == "SEMI_AUTOMATIC_BANK") {
        // 半自动银行
        this.$router.push({ path: "/SaveMonery/BankTransfer2", query });
      } else if (item.parentCode == "OFFLINE_AUTO_ELECTRON") {
        // 全自动电子
        this.$router.push({ path: "/SaveMonery/otherTransfer3", query });
      } else if (item.parentCode == "OFFLINE_AUTO_BANK") {
        // 全自动银行
        this.$router.push({ path: "/SaveMonery/BankTransfer3", query });
      } else {
        this.$router.push({ path: "/SaveMonery/otherTransfer", query });
      }
    },
    goClose() {
      this.isRemind = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/SaveMonery/Base/index.vue